module.exports = __webpack_public_path__ + "media/images/map/payment3-483275cecfdf9315d7489bff467793be.svg";